import { css, IconButton, styled } from '@mui/material';
export const ChangeVideoBackgroundButton = styled(IconButton)(({ theme }) => css `
    background-color: white;
    border-radius: 8px;
    padding: 4px;

    color: ${theme.palette.primary.main};

    &:hover {
      background-color: #f0f0f0;
    }
  `);
